/**
 * 客側(remote)が MQTT で受け取ったイベントごとに、どのAPIを再取得するかの対応表。
 *
 * Remote.vue のローカル定数だったものを、ユニットテストできるようにモジュールへ切り出した
 * （connectionGuard.ts と同じ方針）。store は引数で受け取るため、テストではダミーを渡せる。
 *
 * page が空配列なら全ページで実行、値があればそのページにいるときだけ実行する。
 */

/** 受信するイベント種別（サーバー側の対応表: ModelCommitListener::TABLE_MAP_TOPIC） */
export type MqttEventType =
  | "table_session_order"
  | "table_session_checkout"
  | "update_menu"
  | "update_setting_shop";

export interface MqttPayload {
  type: MqttEventType;
  value?: string;
}

/** Remote.vue のコンポーネント自身(this)。テストでは必要な分だけ持つダミーを渡す */
export interface RemoteContext {
  tabeSessionid?: string;
  $router: { push: (path: string) => void };
}

export interface AcceptCallApiEntry {
  page: string[];
  callApi: (context: RemoteContext, data: MqttPayload) => void;
}

/** dispatch だけ使えればよいので、Vuex Store 全体ではなくこの形で受ける */
export interface DispatchableStore {
  dispatch: (action: string, payload?: any) => any;
}

export function buildAcceptCallApi(
  store: DispatchableStore
): { [key: string]: AcceptCallApiEntry } {
  return {
    table_session_order: {
      page: [],
      callApi: function (context: RemoteContext, data: MqttPayload) {
        if (data.value === context.tabeSessionid) {
          // checkSession はセッションが終了しているときだけ resolve する(継続中は reject)。
          // つまりこの push は会計済みになったときだけ発火する。
          store.dispatch("checkSession").then(() => {
            context.$router.push("/settle-complete");
          });
          store.dispatch("fetchMenus");
          // ODR-1700: 人数(quantities)はテーブルセッション側の情報で、table-info.json でしか更新されない。
          // ホールでの人数変更は table_sessions の保存 → table_session_order として届くため、ここで
          // 再取得しないと客側は古い人数を参照し続け、最低注文人数の判定(SOMenuDetailPopup)が更新されない
          // （2名以上のメニューが注文できないままになる）。
          store.dispatch("fetchTableInfo");
        }
      },
    },
    table_session_checkout: {
      page: [],
      callApi: function (context: RemoteContext, data: MqttPayload) {
        if (data.value === context.tabeSessionid) {
          store.dispatch("checkSession").then(() => {
            context.$router.push("/settle-complete");
          });
          store.dispatch("fetchMenus");
          store.dispatch("fetchOrderHistory");
        }
      },
    },
    update_menu: {
      page: [],
      callApi: function () {
        store.dispatch("fetchMenus");
      },
    },
    update_setting_shop: {
      page: [],
      callApi: function () {
        store.dispatch("checkSession");
      },
    },
  };
}
